function size(_size) {
  if (!arguments.length) return this.__attrs__.size;
  if (Array.isArray(_size)) { // range만 들어온 경우
    this.__attrs__.size = {range: _size, reverse: false};
  } else if (typeof _size === 'number') { // 숫자만 들어온 경우
    this.__attrs__.size = {range: [_size, _size], reverse: false};
  } else if (typeof _size === 'object') {
    this.__attrs__.size = _size;
  }
  return this;
}

export default size;


// WEBPACK FOOTER //
// ./layouts/default/size.js